export default function formatDuration  (minutes)  {
  if (!minutes || isNaN(minutes)) return "-";

  const h = Math.floor(minutes / 60);
  const m = minutes % 60;

  return `${h}:${m}`;
};
